const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    showExportLeads: ['sweeper-call-center'],
    contactNoContactEnabled: true,
    sweeperLeadCookieName: 'tfg-swpr-ld',
    sweeperLeadCookieMaxAge: 1800,
};

export default config;
